'use client';
import {cn} from '@/lib/utils';
import {useEffect, useMemo, useState} from 'react';

type MediaPreviewProps = {
  refresh?: number;
};
export default function MediaPreview({refresh}: MediaPreviewProps) {
  const [media, setMedia] = useState('');
  const [isOpenPreview, setIsOpenPreview] = useState<boolean>(false);

  const togglePreview = () => {
    setIsOpenPreview(!isOpenPreview);
  };
  const mediaType = useMemo(() => {
    if (!media) return 'unknown';

    if (media.startsWith('http')) {
      // if contain youtube domain
      if (media.includes('youtube.com') || media.includes('youtu.be')) {
        return 'youtube';
      }
    }

    const ext = media.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      case 'mp4':
      case 'webm':
        return 'video';
      default:
        return 'unknown';
    }
  }, [media]);

  const showMedia = (e: any) => {
    setMedia(
      (e.currentTarget as HTMLElement)?.dataset?.media ||
        (e.target as HTMLElement)?.dataset?.media ||
        ''
    );
    togglePreview();
  };

  useEffect(() => {
    document.querySelectorAll('[data-media]')?.forEach((mediaElement) => {
      mediaElement.removeEventListener('click', showMedia);
      mediaElement.addEventListener('click', showMedia);
    });
  }, []);

  useEffect(() => {
    document.querySelectorAll('[data-media]')?.forEach((mediaElement) => {
      mediaElement.removeEventListener('click', showMedia);
      mediaElement.addEventListener('click', showMedia);
    });
  }, [refresh]);

  return (
    <div className="questrial text-[18px]">
      <div
        className={cn(
          'fixed h-screen w-full bg-black/50 z-[100] top-0 left-0 transition-opacity duration-500 ease-in-out ',
          isOpenPreview ? 'opacity-100 ' : 'scale-0 opacity-0 '
        )}
        onClick={togglePreview}
      >
        <div className="absolute right-5 top-5 p-2 z-20">
          <div className="">
            <div className="rounded-full bg-[#000000] w-8 h-8 flex justify-center items-center text-white cursor-pointer opacity-50 hover:opacity-100 transition-all duration-200">
              <span className="material-symbols outlined">close</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center text-white ">
          <div className="h-screen w-full overflow-hidden flex justify-center items-center ">
            <div className="w-full flex justify-center items-center overflow-hidden">
              {mediaType == 'image' && (
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="max-w-[80vw] max-h-[80vh] object-contain"
                  alt=""
                  src={media}
                />
              )}
              {mediaType == 'video' && (
                <video
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="max-w-[80vw] max-h-[80vh] "
                  src={media}
                  autoPlay
                  muted
                  controls
                />
              )}
              {isOpenPreview && mediaType == 'youtube' && (
                <div
                  className="max-w-[80vw] max-h-[80vh] w-full h-full"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <iframe
                    src={media}
                    className="aspect-video h-full max-w-[80vw] max-h-[80vh]"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
